import * as React from 'react';

function SvgPinterestMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 11.894c0 2.173.825 4.107 2.595 4.828.29.118.55.004.635-.316.058-.222.197-.782.259-1.014.085-.318.052-.429-.183-.705-.51-.6-.837-1.378-.837-2.478 0-3.194 2.398-6.053 6.24-6.053 3.404 0 5.275 2.074 5.275 4.843 0 3.644-1.618 6.72-4.018 6.72-1.327 0-2.32-1.095-2.001-2.435.381-1.601 1.119-3.329 1.119-4.484 0-1.034-.557-1.897-1.71-1.897-1.355 0-2.444 1.397-2.444 3.27 0 1.193.405 2 .405 2L9.704 21.06c-.484 2.044-.072 4.549-.038 4.802.02.15.214.186.301.072.125-.162 1.74-2.15 2.289-4.135.155-.562.891-3.473.891-3.473.44.837 1.728 1.575 3.096 1.575 4.075 0 6.839-3.703 6.839-8.66 0-3.75-3.184-7.24-8.024-7.24C9.036 4 6 8.305 6 11.894z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgPinterestMono;
